import { render, staticRenderFns } from "./InfoDependentMBL.vue?vue&type=template&id=62d8362c&scoped=true"
import script from "./InfoDependentMBL.vue?vue&type=script&lang=js"
export * from "./InfoDependentMBL.vue?vue&type=script&lang=js"
import style0 from "./InfoDependentMBL.vue?vue&type=style&index=0&id=62d8362c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d8362c",
  null
  
)

export default component.exports